import "./FireProtection.module.css";
import Header from "@/reusable_sections/Header";
import HeroProtection from "./sections/HeroProtection";
import FireProtection from "./sections/FireProtection";
import Contactcta from "./sections/Contactcta";
import Footer from "@/reusable_sections/Footer";
export default function FireProtectionPage() {
  return <div>
      <Header />
      <HeroProtection />
      <FireProtection />
      <Contactcta />
      <Footer />
    </div>;
}